import { CampaignsService } from '../services';
import { useOfficeDiscountHistoryMutation } from './useOfficeDiscountHistoryMutation';

/**
 * Applies a promo code to one office (GOTU-9821). On success the office's
 * history is invalidated, so the new row — with the admin as its applier —
 * comes from the service rather than being guessed here.
 *
 * `mutate(code, { onSuccess, onError })`.
 */
export const useApplyOfficePromoCode = (officeId) =>
  useOfficeDiscountHistoryMutation(
    officeId,
    (code) => CampaignsService.applyOfficePromoCode(officeId, code),
  );
